import React, {useState, useEffect, useMemo} from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import {dataSourceV2} from "commons-ui/core/DataSource";
import {default as NextLink} from "next/link";
import { useStore } from "../../context/state";
import { useRouter } from "../../hooks/useRouter";
import BlogCategoryMenu from "../../components/BlogCategoryMenu";
import BlogCategoryContent from "../../components/BlogCategoryContent";
import queryString from "query-string";
import { SubMenu } from "../../components/SubMenu";
import "./style.styl";



export default function Blog(props) {
    const {isMobile, dispatch, blogPath} = useStore();
    const [categoryList, setCategoryList] = useState([]);

    const requestCategoryList = () => {
        dataSourceV2("wp-json/wp/v2/categories", {url: blogPath})
            .then(v=> {
                const items = (v || []).filter(k => k.slug !== "uncategorized");
                setCategoryList(items);
            });
    };

    useEffect(() => {
        requestCategoryList();
    }, []);



    return (
        <div className="blog-page background-wrapper">
          <div className="container u-xs-padding0">
            <div
              className="paper-box u-paddingLeft80 u-paddingRight80 u-xs-paddingHorizontal24"
              style={{ minHeight: "calc(100vh - 65px)" }}
            >
              <SubMenu />
              <span className="u-textColorPrimary u-fontSize28 u-fontWeightBold">
                WHAT'S NEW
              </span>
              <div className="u-marginTop10 u-paddingBottom8 u-borderBottom1 u-borderColorLighter">
                <Breadcrumbs className=" u-textColorDarker" aria-label="breadcrumb">
                  <Link href="/" color="inherit" className="u-cursorPointer">
                    Home
                  </Link>
                  <Typography >What's New</Typography>
                </Breadcrumbs>
              </div>
              <div className="">
                  <div className="u-marginBottom30 u-xs-marginBottom30 u-marginTop40 u-xs-marginTop20 u-hide">
                      <BlogCategoryMenu items={categoryList} selected={"main"}/>
                  </div>
                  <div className="u-marginTop50">
                      {
                          categoryList.map((category, i) => {
                              return (
                                  <BlogCategoryContent {...props} key={i} category={category} noTitle renderAll/>
                              );
                          })
                      }
                  </div>
              </div>
            </div>
          </div>
        </div>
    );
}
